import React from "react"
import Section from "@components/section"
import BottomContainer from "@components/bottomContainer"
import Title from "@components/title"
import Frame from "@components/frame"
import config from "@config"
import classnames from "@utils/classnames"
import styles from "./eventInfo.module.scss"

import locateImage from "@images/locate.png"

const renderInfo = (text, info, className) => {
  return (
    <div className={classnames(styles.info, className)}>
      <dt>{text}</dt>
      <dd>{info}</dd>
    </div>
  )
}

const renderTitle = (title, sub) => {
  return (
    <h3>
      <span>{title}</span>
      <small>{sub}</small>
    </h3>
  )
}

const Intro = () => {
  return (
    <Section id="block-info">
      <div className={styles.container}>
        <div className={styles.item}>
          {renderTitle("票价", "PRICE")}
          {renderInfo(
            <>
              单日早鸟票
              <br />
              （4月23日后回归常规价）
            </>,
            <>
              116 RMB <small>/ DAY</small>
            </>
          )}
          {renderInfo(
            "单日常规价",
            <>
              129 RMB <small>/ DAY</small>
            </>
          )}
        </div>
        <div className={styles.item}>
          {renderTitle("时间", "DATE")}
          {renderInfo("DAY 1 - 5.15 SAT", <>9:00 - 17:00</>, styles.dateInfo)}
          {renderInfo("DAY 2 - 5.16 sun", <>9:00 - 16:30</>, styles.dateInfo)}
        </div>
        <div className={styles.item}>
          {renderTitle("地址", "LOCATION")}
          <div className={styles.address}>
            <p>北京亦创国际会展中心北京市大兴区 亦庄荣昌东街 6 号</p>
            <a href="https://j.map.baidu.com/2e/Xj" target="_blank">
              <img src={locateImage} />
            </a>
          </div>
        </div>
      </div>
      <BottomContainer>
        <Frame type="button" href={config.urls.buy}>
          立刻购票
        </Frame>
      </BottomContainer>
    </Section>
  )
}

export default Intro
